<div class="">
  <input
    pInputText
    type="text"
    placeholder="Customer Search"
    class="mb-3"
    (input)="onSearchInput($event)"
  />

  <p-table
    #dt
    [value]="scores"
    [(selection)]="selectedScore"
    selectionMode="single"
    [scrollable]="true"
    scrollHeight="400px"
  >
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="customerName">Customer</th>
        <th pSortableColumn="shortTermScore">Short Term Score</th>
        <th pSortableColumn="longTermScore">Long Term Score</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-data>
      <tr (dblclick)="editScore()" [pSelectableRow]="data">
        <td>{{ data.customerName }}</td>
        <td style="text-align: center">{{ data.shortTermScore }}</td>
        <td style="text-align: center">{{ data.longTermScore }}</td>
      </tr>
    </ng-template>
  </p-table>

  <!---- DATATABLE DEPRECATED ----
  <p-dataTabl #dt [value]="scores" [(selection)]="selectedScore" selectionMode="single"
               (onRowDblclick)="editScore()" [scrollable]="true" scrollHeight="400px">
    <p-column field="customerName" header="Customer" [sortable]="tru">
      <ng-template let-data="rowData" pTemplate="body">
        {{ data.customerName }}
      </ng-template>
    </p-column>
    <p-column field="shortTermScore" header="Short Term Score" [sortable]="tru">
      <ng-template let-data="rowData" pTemplate="body">
        {{ data.shortTermScore }}
      </ng-template>
    </p-column>
    <p-column field="longTermScore" header="Long Term Score" [sortable]="tru">
      <ng-template let-data="rowData" pTemplate="body">
        {{ data.longTermScore }}
      </ng-template>
    </p-column>
  </p-dataTable>

  ----->

  <div class="text-right p-3">
    <button pButton label="Edit" (click)="editScore()" [disabled]="!selectedScore"></button>
  </div>
</div>

<p-dialog
  header="Update Customer Sensitivity Scores"
  [(visible)]="showEditScore"
  [modal]="true"
  [style]="{ width: '500px' }"
>
  <div *ngIf="updateScoresDto">
    <div class="text-2xl mb-4">{{ updateScoresDto.customerName }}</div>
    <div class="grid">
      <div class="col-4">
        <label>Short Term Score</label>
      </div>

      <div class="col-8 px-2">
        <p-selectButton
          class="w-full mb-4"
          [options]="allowedScores"
          [(ngModel)]="updateScoresDto.shortTermScore"
        ></p-selectButton>
      </div>

      <div class="col-4">
        <label>Long Term Score</label>
      </div>

      <div class="col-8 px-2">
        <p-selectButton
          class="w-full mb-4"
          [options]="allowedScores"
          [(ngModel)]="updateScoresDto.longTermScore"
        ></p-selectButton>
      </div>
    </div>
  </div>
  <p-footer>
    <button
      (click)="saveScore()"
      pButton
      [label]="saving ? 'Wait..' : 'Save'"
      [disabled]="saving"
    ></button>
  </p-footer>
</p-dialog>
